
import { StepIndicatorProps } from "../../types";

export const StepIndicator: React.FC<StepIndicatorProps & { isLast?: boolean }> = ({
  step,
  isActive,
  isCompleted,
  isLast = false,
}) => {

  return (

    <div className="flex w-full items-center flex-1">
      {/* Step badge + label */}
      <div className="flex items-center gap-2 shrink-0">
        {/* Number badge — uses step.id as the number */}
        <div
          className={`w-6 h-6 rounded-md flex items-center justify-center text-sm font-semibold shrink-0 transition-all ${isActive
            ? "bg-green-500 text-white"
            : isCompleted
              ? "bg-green-500 text-white"
              : "bg-transparent text-[#535A79] dark:text-gray-400 border border-gray-300 dark:border-gray-600"
            }`}
        >
          {step.id}
        </div>

        {/* Label */}
        <span
          className={`text-sm font-medium whitespace-nowrap transition-all ${isActive
            ? "text-gray-900 dark:text-gray-100"
            : isCompleted
              ? "text-black dark:text-gray-200"
              : "text-[#535A79] dark:text-gray-400"
            }`}
        >
          {step.title}
        </span>
      </div>

      {/* Connecting line — hidden on last step */}
      {!isLast && (
        <div
          className={`flex-1 mx-2 h-[2px] min-w-[32px] transition-all ${isCompleted ? "bg-black dark:bg-gray-300" : "bg-gray-200 dark:bg-gray-700"
            }`}
        />
      )}
    </div>
  );
};